import React, { useState, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ComplaintResolution = ({ show, onClose, data, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    
    const [reason, setReason] = useState('');

    const [userName, setUserName] = useState("");
    
    useEffect(() => {
        const token = localStorage.getItem("token");
        console.log(token);
        if (token) {
        axios
            .get(`${baseURL}/me`, {
            headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setUserName(res.data.name || "User");
            })
            .catch((err) => {
                console.error("Failed to fetch user info:", err);
                setUserName("User");
            });
        } else {
            setUserName("Guest");
        }
    }, []);

    const formatDateTime = (date) => {
        const pad = (n) => (n < 10 ? '0' + n : n);

        return (
            date.getFullYear() +
            '-' +
            pad(date.getMonth() + 1) +
            '-' +
            pad(date.getDate()) +
            ' ' +
            pad(date.getHours()) +
            ':' +
            pad(date.getMinutes()) +
            ':' +
            pad(date.getSeconds())
        );
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!reason) {
            newErrors.reason = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        let postData = {
            reason_datetime: formatDateTime(new Date()),
            reason_provider_name: userName || '',
            reason: reason,
            complaint_status: 2
        }

        axios.put(`${baseURL}/complaint/${data.complaint_id}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Complaint Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Complaint Updation Failed");
            });
    };

    return (
        <Modal show={show} onHide={onClose} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{  backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Complaint Resolved</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Date / Time</label>
                            <label className="text-danger fs-6 font-w500">
                                <span>{data.date}</span>
                                <span>/</span>
                                <span>{data.time}</span>
                            </label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Customer</label>
                            <label className="col-7 text-black font-w500 fs-6">{data.subscriber_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Phone No</label>
                            <label className="col-7 text-black font-w500 fs-6">{data.subscriber_mobile}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Product Period</label>
                            <label className="col-7 text-black font-w500 fs-6">{data.timeline_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Complaint Type</label>
                            <div>
                                <Badge bg="info" className='text-white fs-7 py-0 px-1'>
                                    <span>{data.c_type_name}</span>
                                </Badge>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Product</label>
                            <label className="text-black font-w500 fs-6">{data.product_name}</label>
                        </div>
                        <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Complaint</label>
                            <label className="text-black font-w500 fs-6"> &emsp; &emsp;{data.complaint_convo}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Response<span className="required">*</span></label>
                            <textarea rows={3} className="form-control h-auto mw-auto" name="comment" placeholder="Enter Response" 
                                maxLength={500}
                                value={reason}
                                onChange={e => setReason(e.target.value)}
                            />
                            {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Complaint Resolved</Link>
                    </div>
                </div>


            </div>
        </Modal >
    );
};

export default ComplaintResolution;
